<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 324 61.92">
    <title>Product of MultiTech</title>
    <path :fill="primary" d="M1.89 14.62h9.57l7.8 12.65 7.8-12.65h9.56V47.3h-9V28.53l-8.34 12.8h-.19l-8.28-12.7V47.3H1.89zM57.16 47.9c-2.34 0-4.44-.29-6.3-.88a12.2 12.2 0 0 1-4.77-2.73 12.04 12.04 0 0 1-3.01-4.67c-.7-1.88-1.05-4.1-1.05-6.65V14.62h9.24v18.16c0 2.37.54 4.12 1.62 5.25a5.73 5.73 0 0 0 4.36 1.7c1.82 0 3.27-.54 4.35-1.63 1.08-1.09 1.62-2.78 1.62-5.09V14.62h9.25v18.11c0 2.65-.37 4.93-1.1 6.84s-1.76 3.49-3.08 4.72a12.39 12.39 0 0 1-4.8 2.73c-1.9.59-4 .89-6.34.89M77.87 14.62h9.06v24.74h14.16v7.94H77.87zM106.5 22.56h-9.81v-7.94h28.66v7.94h-9.8V47.3h-9.06zM129.41 14.62h9.1V47.3h-9.1z"/>
    <path :fill="secondary" d="M153.54 18.03h-10.98v-3.41h25.63v3.4h-10.97V47.3h-3.68zM172.25 14.62h22.05v3.31h-18.36v11.25h15.59v3.32h-15.6v11.48h18.32v3.32h-22zM228.44 14.62h3.68v14.52h18.86V14.62h3.7V47.3h-3.7V32.6h-18.86v14.7h-3.69z"/>
    <path :fill="primary" d="M292 .84a30.15 30.15 0 0 0-30.12 30.12A30.15 30.15 0 0 0 292 61.08a30.15 30.15 0 0 0 30.11-30.12c0-16.6-13.5-30.12-30.1-30.12m0 50.3a20.2 20.2 0 0 1-20.2-20.18 20.2 20.2 0 0 1 20.2-20.18 20.2 20.2 0 0 1 20.17 20.18A20.2 20.2 0 0 1 292 51.14"/>
    <path :fill="innerRing" d="M292 51.14a20.2 20.2 0 0 1-20.19-20.18 20.2 20.2 0 0 1 20.2-20.18 20.2 20.2 0 0 1 20.17 20.18A20.2 20.2 0 0 1 292 51.14"/>
    <path :fill="secondary" d="M308.87 30.96a16.87 16.87 0 1 0-33.74 0 16.87 16.87 0 0 0 33.74 0"/>
    <path :fill="secondary" d="M221.88 40.38a12.9 12.9 0 0 1-9.42 4.14c-4.08 0-7.74-1.93-10.15-4.94-1.88-2.35-3-5.35-3-8.62 0-3.27 1.12-6.28 3-8.62a12.99 12.99 0 0 1 10.15-4.94c3.7 0 7.03 1.59 9.42 4.13l2.5-2.5a16.87 16.87 0 1 0 0 23.86l-2.5-2.5zM259.63 19.57a2.64 2.64 0 0 1-1.9-.8 2.72 2.72 0 0 1-.8-1.88 2.6 2.6 0 0 1 .8-1.91 2.7 2.7 0 0 1 4.38.85c.14.32.2.67.2 1.04a2.62 2.62 0 0 1-.78 1.91 2.7 2.7 0 0 1-1.9.79m0-4.81a2.06 2.06 0 0 0-1.5.62 2.06 2.06 0 0 0-.62 1.5 2.08 2.08 0 0 0 .62 1.5 2.1 2.1 0 0 0 2.32.45 2.11 2.11 0 0 0 1.13-2.78 2.15 2.15 0 0 0-1.13-1.13c-.26-.1-.53-.16-.82-.16m1.56 3.52h-.74l-.8-1.05h-.54v1.05h-.6v-2.94h1.27c.37 0 .66.1.87.3.16.17.25.38.25.62 0 .3-.1.52-.3.68-.08.08-.18.14-.3.18l.9 1.16zm-2.08-1.63h.65c.19 0 .33-.04.43-.11a.3.3 0 0 0 .12-.26c0-.12-.03-.2-.11-.26-.1-.07-.24-.1-.44-.1h-.65v.73z"/>
  </svg>
</template>


<script>
export default {
  name: 'LogoMultitech',
  props: {
    white: Boolean,
  },
  computed: {
    primary() {
      return this.white ? '#FFF' : '#0072CE'
    },
    secondary() {
      return this.white ? '#FFF' : '#000'
    },
    innerRing() {
      return this.white ? '#000' : '#FFF'
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/LogoMultitech.vue